(() => {
  if (window.__pzCartCompetitorV1) return;
  window.__pzCartCompetitorV1 = true;

  const qs = (selector, root = document) => root.querySelector(selector);
  const qsa = (selector, root = document) => Array.from(root.querySelectorAll(selector));

  function installCartCleanupStyles() {
    if (document.getElementById('PzCartCleanupStyles')) return;
    const style = document.createElement('style');
    style.id = 'PzCartCleanupStyles';
    style.textContent = `
      .pz-cart-preview-link { display: none !important; }
      .pz-cart-summary .pz-cart-main-checkout {
        width: 100% !important;
        max-width: none !important;
        min-width: 0 !important;
        margin-left: 0 !important;
        margin-right: 0 !important;
        box-sizing: border-box !important;
      }
    `;
    document.head.appendChild(style);
  }

  function initTimer() {
    const nodes = qsa('[data-pz-cart-timer]');
    if (!nodes.length) return;

    const storageKey = 'pzCartReminderEndsAt';
    const duration = 10 * 60 * 1000;
    let endsAt = Number(sessionStorage.getItem(storageKey));
    const now = Date.now();

    if (!endsAt || Number.isNaN(endsAt) || endsAt <= now) {
      endsAt = now + duration;
      sessionStorage.setItem(storageKey, String(endsAt));
    }

    const render = () => {
      const remaining = Math.max(0, endsAt - Date.now());
      const totalSeconds = Math.ceil(remaining / 1000);
      const minutes = Math.floor(totalSeconds / 60);
      const seconds = totalSeconds % 60;
      const value = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
      nodes.forEach((node) => { node.textContent = value; });
      if (remaining <= 0) sessionStorage.removeItem(storageKey);
    };

    render();
    window.setInterval(render, 1000);
  }

  function initPreviewModal() {
    const modal = qs('[data-pz-preview-modal]');
    if (!modal) return;
    const image = qs('[data-pz-preview-modal-image]', modal);
    const closeButtons = qsa('[data-pz-preview-close]', modal);

    const close = () => {
      modal.hidden = true;
      document.documentElement.classList.remove('pz-cart-modal-open');
      if (image) image.removeAttribute('src');
    };

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-pz-preview-image]');
      if (!trigger) return;
      const src = trigger.getAttribute('data-pz-preview-image');
      if (!src) return;
      event.preventDefault();
      if (image) {
        image.src = src;
        image.alt = trigger.getAttribute('data-pz-preview-alt') || 'Personalized item preview';
      }
      modal.hidden = false;
      document.documentElement.classList.add('pz-cart-modal-open');
      qs('[data-pz-preview-close]', modal)?.focus();
    });

    closeButtons.forEach((button) => button.addEventListener('click', close));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !modal.hidden) close();
    });
  }

  async function getCart() {
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    });
    if (!response.ok) throw new Error('Unable to read cart');
    return response.json();
  }

  let cleanupRunning = false;
  let cleanupQueued = false;

  async function cleanCartPresentation() {
    if (cleanupRunning) return;
    cleanupRunning = true;

    qsa('.pz-cart-preview-link').forEach((button) => button.remove());

    const optionGroups = qsa('.pz-cart-card .pz-cart-options');
    optionGroups.forEach((group) => { group.style.visibility = 'hidden'; });

    try {
      const cart = await getCart();
      const cards = qsa('.pz-cart-card');

      cards.forEach((card, index) => {
        const properties = cart.items?.[index]?.properties || {};
        const propertyNames = new Set(Object.keys(properties).map((name) => name.trim().replace(/:$/, '')));

        qsa('.pz-cart-option', card).forEach((row) => {
          const label = qs('dt', row)?.textContent?.trim().replace(/:$/, '');
          if (label && propertyNames.has(label)) row.remove();
        });

        const group = qs('.pz-cart-options', card);
        if (group) {
          group.style.visibility = '';
          if (!group.querySelector('.pz-cart-option')) group.remove();
        }
      });
    } catch (error) {
      console.error('[PZ Cart Cleanup]', error);
      optionGroups.forEach((group) => { group.style.visibility = ''; });
    } finally {
      cleanupRunning = false;
    }
  }

  function scheduleCartCleanup() {
    if (cleanupQueued) return;
    cleanupQueued = true;
    window.requestAnimationFrame(() => {
      cleanupQueued = false;
      cleanCartPresentation();
    });
  }

  function observeCartRefreshes() {
    const target = qs('#main-cart-items') || document.body;
    if (!target || !('MutationObserver' in window)) return;
    const observer = new MutationObserver(scheduleCartCleanup);
    observer.observe(target, { childList: true, subtree: true });
  }

  async function setAddon(input) {
    const variantId = Number(input.dataset.pzAddonVariant);
    if (!variantId) return;

    input.disabled = true;
    input.closest('.pz-cart-addon')?.setAttribute('aria-busy', 'true');

    try {
      const cart = await getCart();
      const existing = cart.items.find((item) => Number(item.variant_id) === variantId);
      const root = window.Shopify?.routes?.root || '/';

      if (input.checked && !existing) {
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: { _pz_cart_addon: input.dataset.pzAddonKind || 'addon' } }] })
        });
        if (!response.ok) throw new Error('Unable to add service');
      } else if (!input.checked && existing) {
        const response = await fetch(`${root}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ id: existing.key, quantity: 0 })
        });
        if (!response.ok) throw new Error('Unable to remove service');
      }

      window.location.reload();
    } catch (error) {
      console.error('[PZ Cart Add-on]', error);
      input.checked = !input.checked;
      input.disabled = false;
      input.closest('.pz-cart-addon')?.removeAttribute('aria-busy');
    }
  }

  function initAddons() {
    document.addEventListener('change', (event) => {
      const input = event.target.closest('[data-pz-addon-variant]');
      if (input) setAddon(input);
    });
  }

  function initStickyCheckout() {
    const sticky = qs('[data-pz-sticky-checkout]');
    const main = qs('[data-pz-main-checkout]');
    if (!sticky || !main || !('IntersectionObserver' in window)) return;

    const observer = new IntersectionObserver(([entry]) => {
      sticky.classList.toggle('pz-sticky-checkout--hidden', entry.isIntersecting);
    }, { threshold: 0.2 });
    observer.observe(main);
  }

  function init() {
    installCartCleanupStyles();
    initTimer();
    initPreviewModal();
    initAddons();
    cleanCartPresentation();
    observeCartRefreshes();
  }

  installCartCleanupStyles();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
